import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import WelcomeScreen from './components/WelcomeScreen';
import MainScreen from './components/MainScreen';
import ABTestSetupScreen from './components/ABTestSetupScreen';
import ABTestResultsScreen from './components/ABTestResultsScreen';
import HakkimizdaPage from './components/HakkimizdaPage';
import GizlilikPolitikasiPage from './components/GizlilikPolitikasiPage';
import GlobalStyles from './styles/GlobalStyles';
import { theme } from './styles/theme';
import { AnalyticsListener } from './analytics';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <AnalyticsListener />
        <Routes>
          <Route path="/" element={<WelcomeScreen />} />
          <Route path="/hakkimizda" element={<HakkimizdaPage />} />
          <Route path="/gizlilik-politikasi" element={<GizlilikPolitikasiPage />} />
          <Route path="/chat" element={<MainScreen />} />
          <Route path="/ab-test-setup" element={<ABTestSetupScreen />} />
          <Route path="/ab-test-results" element={<ABTestResultsScreen />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
